
export class CountryListModel {
  id: string;
  name: string;
  constructor( obj: {
    idPais: string;
    desPais: string;
  } ) {
  //   if ( !obj ) { return; }

    this.id = obj && obj.idPais ? obj.idPais : '';
    this.name = obj && obj.desPais ? obj.desPais : '';
  }
}
